import React, { useState } from 'react';
import Input from '@amzn/meridian/input';

export interface DoubleClickInputProps {
  value: number;
  onChange: (inputValue: number) => void;
}
const DoubleClickInput = (props: DoubleClickInputProps) => {
  const { value, onChange } = props;
  const [inputMode, setInputMode] = useState(false);
  const [inputValue, setInputValue] = useState<number>(value);

  const handleDoubleClick = () => {
    setInputMode(true);
  };

  const handleBlur = () => {
    setInputMode(false);
    onChange(inputValue);
  };

  const handleInputChange = (input: number) => {
    setInputValue(Math.max(input, 1));
  };

  return (
    <div onDoubleClick={handleDoubleClick}>
      {inputMode ? (
        <Input
          onBlur={handleBlur}
          type="number"
          value={inputValue}
          width="120px"
          onChange={handleInputChange}
          role="spinbutton"
        />
      ) : (
        <span>{value}</span>
      )}
    </div>
  );
};

export default DoubleClickInput;
